import React from 'react';
import {
  Box,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

const infrastructureUrls = [
  { name: 'Project Console', urls: ['https://console.firebase.google.com/project/mobidawg-native-db/overview'] },
  { name: 'Mobidawg Native DB', urls: ['https://mobidawg-native-db.web.app', 'https://mobidawg-native-db.mobidawg.com'] },
  { name: 'Tag Sales', urls: ['https://tagsales.web.app', 'https://tagsales.mobidawg.com'] },
  { name: 'Ineffabilis', urls: ['https://ineffabilis.web.app', 'https://ineffabilis.mobidawg.com'] },
  { name: 'Measured Meals', urls: ['https://measuredmeals.web.app', 'https://measuredmeals.mobidawg.com'] },
  { name: 'Siteworker', urls: ['https://siteworker.web.app', 'https://siteworker.mobidawg.com'] },
  { name: 'Stockanalyze', urls: ['https://stockanalyze.web.app', 'https://stockanalyze.mobidawg.com'] },
  { name: 'Ted Outdoors', urls: ['https://tedoutdoors.web.app', 'https://tedoutdoors.mobidawg.com'] },
];

function ViewProductPages() {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Mobidawg Infrastructure
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 3 }}>
        Quick access to the consoles and hosted applications supporting the Mobidawg infrastructure and products.
      </Typography>

      <TableContainer component={Paper}>
        <Table aria-label="Mobidawg infrastructure URLs">
          <TableHead style={{ backgroundColor: 'lightblue' }}>
            <TableRow>
              <TableCell style={{ textColor: 'white', fontWeight: 'bold' }}>{"Project".toUpperCase()}</TableCell>
              <TableCell style={{ textColor: 'white', fontWeight: 'bold' }}>{"URL".toUpperCase()}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {infrastructureUrls.map((item) => (
              <TableRow key={item.name}>
                <TableCell component="th" scope="row">
                  <Link href={item.urls[0]} target="_blank" rel="noopener noreferrer">
                    {item.name}
                  </Link>
                </TableCell>
                <TableCell>
                  {item.urls.map((url) => (
                    <Box key={url} sx={{ display: 'block' }}>
                      <Link href={url} target="_blank" rel="noopener noreferrer">
                        {url}
                      </Link>
                    </Box>
                  ))}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default ViewProductPages;